import {useEffect} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import MainDesign from "../../pages/MainDesign";

interface RedirectComponentProps {
    to: string,
    from?: string
    onRedirect?: () => void
    onRedirectAsync?: () => Promise<void>
}

export default function RedirectComponent({to, from, onRedirect, onRedirectAsync}: RedirectComponentProps) {
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const source = searchParams.get('source');

    useEffect(() => {
        function handleRedirect() {
            if (from) {
                window.location.href = `${to}?source=${from}`;
            } else if (source) {
                window.location.href = `${to}?source=${source}`;
            } else {
                window.location.href = to;
            }
        }

        if (onRedirect) {
            onRedirect();
        }
        if (onRedirectAsync) {
            onRedirectAsync().then(() => handleRedirect());
        } else {
            handleRedirect();
        }
    }, [to, navigate, onRedirect, onRedirectAsync, from, source]);
    
    return <MainDesign minHeight='100vh'>
        <p></p>
    </MainDesign>;
};